<div class="container-fluid">
  <form-workflow
    [form]="form"
    sectionTitle="Review & Authorization"
    [sectionNumber]="2"
    [amendmentSectionNumbers]="[10]"
    [service]="service"
  >
  </form-workflow>
</div>
